import React from "react"

import { isNil } from "ramda"

import i18n from "@cirrus/legacy/app-common/alt/framework/i18n"

import { dialogStyles } from "./styles"
import { MuiIcon } from "../../atoms"
import { Table } from "../table-mui"

export const DialogTable = ({
  data = [],
  loading,
  width = false,
  noItemsFoundMessage = i18n("Framework:TotalFound").replace("{0}", "0"),
  hideCustomizeColumn = true,
  searchOnLeft = false,
  minHeight = "354px",
  ...tableProps
}) => {
  const classes = dialogStyles({ width })
  const additionalProps = {}

  if (!!tableProps.total) additionalProps.tableHeight = "286px"
  if (!tableProps.total && !loading)
    additionalProps.noResultsText = (
      <div className={classes.noItems}>
        <MuiIcon.SearchOff />
        <div>{noItemsFoundMessage}</div>
      </div>
    )

  return (
    <>
      <div className={classes.table}>
        <Table
          autoHeight={false}
          hideFooterPagination={true}
          {...{
            ...tableProps,
            data,
            ...additionalProps,
          }}
          searchOnLeft={searchOnLeft}
          enableInfoIcon={false}
          enableFirstColumnWidth={false}
          autoLoad={!isNil(tableProps.autoLoad) ? tableProps.autoLoad : true}
          loading={loading}
          filterForm={classes.filterForm}
          hideCustomizeColumn={hideCustomizeColumn}
        />
        {!loading && (
          <div className={classes.tableTotalItems}>
            {!!tableProps.total && i18n("Framework:TotalFound").replace("{0}", tableProps.total)}
          </div>
        )}
      </div>
    </>
  )
}
